import { Reference } from '@volkswagen-onehub/disclaimer-manager/dist-es/api';

export interface RegisteredDisclaimers {
	[key: string]: RegisteredDisclaimer;
}

export interface NamedDisclaimer {
	readonly ref: string;
	readonly text: string;
}

export interface RegisteredDisclaimer {
	readonly text: string;
	readonly ref: Reference | undefined;
	readonly type: 'legal' | 'legal cuota';
	readonly onClick?: () => void;
}

export type DisclaimerType = string | NamedDisclaimer;

export const getDisclaimerText = (disclaimer: DisclaimerType): string | undefined => {
	return typeof disclaimer === 'string' ? disclaimer : disclaimer?.text;
};

export function isStandardReferenceDisclaimer(disclaimer: DisclaimerType): disclaimer is string {
	return typeof disclaimer === 'string';
}

export const handleScrollToDisclaimer = (reference: string) => {
	//Guardamos la posición inicial
	const initialScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

	//El footer de legales ya no usa <dl><dt><dd>, ahora es <ol data-component="disclaimer"><li><span>N.</span><div>texto</div></li></ol>
	const allItems = document.querySelectorAll('ol[data-component="disclaimer"] > li');

	for (const li of Array.from(allItems)) {
		//El número del legal es el primer hijo del li (span con texto "2.")
		const numberEl = li.firstElementChild;

		if (numberEl?.textContent?.trim() === `${reference}.`) {
			//El segundo hijo del li contiene el texto del legal
			const textWrap = li.children[1] as HTMLElement | undefined;

			if (textWrap) {
				//Ahora cogemos el contenedor del mensaje del legal para añadirle el (volver arriba)
				if (!textWrap.querySelector('.back-to-top')) {
					const span = document.createElement('span');
					span.className = 'back-to-top';
					span.style.cssText = 'display:block;cursor:pointer;color:inherit;text-decoration:underline;font-weight:bold;';
					span.textContent = '↑ Volver arriba';
					span.onclick = () => {
						//Activamos el auto scroll para volver al legal y desactiamos el autoscroll al pasar 1500ms
						window.scrollTo({
							top: initialScrollPosition,
							behavior: 'smooth',
						});
						span.remove();
					};
					textWrap.appendChild(span);
				}

				//Obtenemos la posicion del legal en la lista
				const rect = li.getBoundingClientRect();
				//Obtenemos cuanto se ha scrolleado ya para tenerlo en cuenta
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				//Hacemos scroll automatico con 100 px de margen
				window.scrollTo({
					top: scrollTop + rect.top - 100,
					behavior: 'smooth',
				});
				//Hacemos focus en el legal
				setTimeout(() => {
					li.setAttribute('tabindex', '-1');
					(li as HTMLElement).focus();
				}, 800);

				return;
			}
		}
	}
};
